import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { WINDOW } from '@adnoc/servicebox';

import { SandboxLocalStorageKeys } from '../enums';
import { SandboxMobileSwitchConfirmationComponent } from '../components';

import { SandboxLocalStorageService } from './local-storage.service';

@UntilDestroy()
@Injectable()
export class SandboxMobileService {
  private readonly isMobile$ = new BehaviorSubject<boolean>(
    this.sandboxLocalStorageService.getItemValue(SandboxLocalStorageKeys.mobileMode) === true,
  );

  constructor(
    private sandboxLocalStorageService: SandboxLocalStorageService,
    private matDialog: MatDialog,
    @Inject(WINDOW) private window: Window,
  ) {}

  get isMobileMode$() {
    return this.isMobile$.asObservable();
  }

  get isMobileMode(): boolean {
    return this.isMobile$.getValue();
  }

  updateIsMobile(isMobile: boolean): void {
    this.matDialog
      .open(SandboxMobileSwitchConfirmationComponent)
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe((confirmed) => {
        if (confirmed === true) {
          this.sandboxLocalStorageService.setItemValue(SandboxLocalStorageKeys.mobileMode, isMobile);
          this.window.location.reload();
        }
      });
  }
}
